<template>
    <form-accordion
        name="utilities-contracts"
        section="Utilities and Contracts"
        :url="url"
        method="PATCH"
        :closed="closed"
        :read_only="read_only"
    >
        <square-feet
            :read_only="read_only"
        />

        <utilities
            :commercial="property.commercial"
            :read_only="read_only"
        />

        <prior-contracts
            :commercial="property.commercial"
            :read_only="read_only"
        />
    </form-accordion>
</template>

<script>
import SquareFeet from './square-feet.vue';
import Utilities from './utilities.vue';
import PriorContracts from './prior-contracts.vue';

export default {
    components: {
        SquareFeet,
        Utilities,
        PriorContracts,
    },

    props: {
        url: {},
        closed: { default: true },
        property: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
